import ClientPassengerInterface from '../../interfaces/client/Passenger'

export const ADD_PASSENGERS = 'ADD_PASSENGERS'

export default (passengers: ClientPassengerInterface[]) => ({
  type: ADD_PASSENGERS,
  passengers,
})
